<template>
  <div class="goodslist">
    <mt-header title="溯源商品展示" fixed>
        <router-link to slot="left">
          <mt-button icon="back" @click="$router.back(-1)"></mt-button>
        </router-link>
    </mt-header>
    <div class="tabList">
      <div :class="sort_id == item.id ? 'item active' : 'item'" v-for="item in type_list" :key="item.id" @click="chooseCate(item.id)">{{ item.name }}</div>
    </div>
    <scroller :on-infinite="infinite" ref="my_scroller" :on-refresh="refresh">
         <div class="list">
            <div class="item box710" v-for="item in pageData" :key="item.id">
                <img :src="'/' + item.goods_mainshow" alt="" />
                <div class="good">
                    <p class="name">{{ item.goods_name }}</p>
                    <p class="date">添加时间：{{ item.create_time }}</p>
                    <p class="code" v-if="item.sign">溯源码：{{ item.sign.sign_number }}</p>
                    <div class="opt" v-if="item.sign"><span @click="$router.push('/searchResults?_d=ys&sign_number=' + item.sign.sign_number)">查看溯源</span></div>
                </div>
            </div>
        </div>
    </scroller>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      sort_id:0,
      dataPage: 0,
      type_list: [],
      pageData: []
    };
  },
  mounted() {
      
      this.getTypeList();
  },
  methods: {
    //选择分类
    chooseCate(type) {
      this.sort_id = type;
      this.pageData = [];
      this.getlistData(1, 1);
    },
    getTypeList() {
      this.$request.post('/front/Sundries/slists', {}, res => {
        if (res.status == 1) {
          this.type_list = res.result;
          this.sort_id = res.result[0].id || 1;
          this.getlistData(1,1);
        }
      });
    },
    /**
     * 下拉刷新
     */
    refresh() {
      this.getlistData(1, 1);
      //关闭动画
      setTimeout(() => {
        this.$refs.my_scroller.finishPullToRefresh();
      }, 1000);
    },
    /**
     * 上拉加载
     */
    infinite(done) {
      let page = this.dataPage + 1;
      this.getlistData(page, 2, done);
      setTimeout(() => {
        this.$refs.my_scroller.finishInfinite(true);
      }, 1000);
    },
    /**
     * page 分页
     * optType 1下拉刷新，2上拉加载
     */
    getlistData(page, optType, done) {
      if(this.sort_id==0) return '';
      let data = {
        page: page,
        sort_id: this.sort_id
      };
      this.$request.get("/front/api/allGoods", data, res => {
        console.log(res);
        if (res.status == 1) {
          if (optType == 1) {
            //下拉刷新
            this.pageData = res.result;
            this.dataPage = 1;
          } else if (optType == 2) {
            //上拉加载
            if (res.result.length != 0) {
              //判断是否有数据
              this.pageData = this.pageData.concat(res.result);
              this.dataPage = page;
              if (typeof done == "function") {
                done();
              }
            } else {
              //没有更多数据
              this.$refs.my_scroller.finishInfinite(true);
            }
          }
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mint-header{
  height: 1rem;
  background: #050f25;
  color: #0efcff;
}
.goodslist{
  padding-top: 1rem;
}
.tabList {
  width: 100%;
  height: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.2rem;
  box-sizing: border-box;
  background: white;
  position: fixed;
  // top: 1rem;
  z-index: 999;
  .item {
    flex: 1;
    text-align: center;
    height: 0.8rem;
    line-height: 0.8rem;
    border-bottom: 2px solid #ffffff;
  }
  .active {
    color: #6ba9ff;
    border-color: #6ba9ff;
  }
}
  .list {
      margin-top: 2rem;
    .item {
      background: #ffffff;
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 2rem;
        height: 2rem;
        border-radius: 10px;
        margin-right: 0.2rem;
      }
      .good {
        width: 4.5rem;
        height: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
      .name {
        width: 4rem;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .date {
        color: #666666;
        font-size: 0.24rem;
      }
      .code {
        font-size: 0.26rem;
        color: #000000;
      }
      .opt {
        text-align: right;
        span {
          padding: 0.05rem 0.1rem;
          background: #d4e6ff;
          color: #6ba9ff;
          border: 1px solid #9cc5ff;
          border-radius: 5px;
          font-size: 0.26rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/goodsList.vue